<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">AllAccounts</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <ReadAccountTable></ReadAccountTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Read Accounts Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Read Accounts",
    meta: [{ name: "Read Accounts", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Read Accounts",

      items: [
        {
          text: "Accounts",
          href: "/"
        },
        {
          text: "Read Accounts",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
